/* eslint-disable */
export const emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
export const emailLocalRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))$/)
/* eslint-disable */

export const passwordRegex = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/)

export const noSpaceRegex = new RegExp(/^\S+$/)

export const nameRegex = new RegExp(/\S/)

export const nicknameRegex = new RegExp(/^\S*[\u3400-\u9fffA-Za-z]+\S*$/)

export const nicknameLengthRegex = new RegExp(/^\S{1,20}$/)

export const noNumberRegex = new RegExp(/^\D+$/)

export const phoneRegex = new RegExp(/^(09\d{8}|00543\d{5})$/)

const numberOnlyRegex = new RegExp(/^\d+$/)

export const moneyRegex = numberOnlyRegex
export const accountRegex = new RegExp(/^\d{1,14}$/)
export const telRegex = new RegExp(/^(\d|#|-)+$/)
export const taxnumRegex = numberOnlyRegex

export const SMSVerifyTextRegex = new RegExp(/\d{6}$/)

export const last5NumRegex = new RegExp(/^\d{5}$/)

export const last14NumRegex = new RegExp(/^\d{1,14}$/)

export const addressRegex = new RegExp(/^[\u3400-\u9fffa-zA-Z0-9-]{4,}/)

// 会员变更
export const taxnumRegexVerify = new RegExp(/^\d{8}$/)
export const telRegexVerify = new RegExp(/^\d{9,10}$/)

export const msgHttpReg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-|#)+)/g

export const zipcodeRegex = new RegExp(/^\d{3,6}$/)

export const phoneBarcodeRegex = new RegExp(/^\/[a-zA-Z0-9\+\-\.]{7}$/)

export const easyCardRegex = new RegExp(/^\d{9}$/)

export const certificateRegex = new RegExp(/^[A-Z]{2}\d{14}$/)

export const companyUnicodeRegex = new RegExp(/^\d{8}$/)

export const nonNumberNameRegex = new RegExp(/^[\u3400-\u9fffA-Za-z ]+$/)

// 7-11 交貨便姓名：中文 2~5 字，或至少 4 個英文字，不含空白/數字/符號
export const sevenElevenNameRegex = new RegExp(/^([\u3400-\u9fff\u4e00-\u9fff]{2,5}|[A-Za-z]{4,})$/)

export const sevenElevenNameHint = '姓名必須為中文（最長5個字、最短2個字），或英文（最短4個英文字），不能包含空白，不能為數字和符號.'

export const validateSevenElevenName = (val) => ({
  valid: sevenElevenNameRegex.test(val),
  msg: sevenElevenNameHint
})

export const cardVerificationCodeRegex = new RegExp(/^\d{3}$/)

export const creditCardRegex = new RegExp(/^[0-9 ]{16,19}$/)

export const detailAddressRegex = new RegExp(/^\S*(大道|路|街|村|里|鄰|巷|弄|段|衖)+\S*(號|樓|室)+\S*$/)
